<template>
  <v-card variant="text" class="mt-4 mx-auto">
    <v-card-text>
      <v-sheet class="pa-6  mx-auto">
        <h4 class="text-h5 font-weight-bold mb-4">{{ $t('app.Labels.PresentationHeader') }}</h4>
        <p class="text-justify">
          {{ $t('app.Labels.PresentationBody1') }}
          <br><br>
          {{ $t('app.Labels.PresentationBody2') }}
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <a :href="pdfUrl" target="_blank" v-bind="props" @click.stop>
                {{ $t('app.Labels.Link') }}.
              </a>
            </template>
            {{ $t('app.Labels.ClickToViewPolicy') }}
          </v-tooltip>
          {{ $t('app.Labels.PresentationBody21') }}
          <br><br>
          {{ $t('app.Labels.PresentationBody3') }}
          <br><br>
          {{ $t('app.Labels.PresentationBody4') }}
          <br><br>
          {{ $t('app.Labels.PresentationBody5') }}
        </p>
      </v-sheet>
    </v-card-text>
    <v-card-actions class="d-flex align-center">
      <v-spacer></v-spacer>
      <v-btn color="success" variant="flat" @click="next">
        {{ $t('app.Buttons.Next') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'App',
  computed: {
    pdfUrl() {
      const lang = this.$i18n.locale; // Obtiene el idioma actual
      return process.env.BASE_URL + `detalle_${lang.toUpperCase()}.pdf`;
    }
  },
  methods: {
    next() {
      this.$store.commit('SET_VENTANA', 2)
    }
  }
}
</script>
